'use client';

import { c as _c } from "react/compiler-runtime";
import { ThumbsDown, ThumbsUp } from '@byway/icons';
import { Label, Radio, RadioGroup } from '@headlessui/react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { Stack, Text } from 'ui';
import { SimpleSpinner } from '~/components/Spinner';
import { api } from '~/libs/api';
type ThumbsUpAndDownVoteProps = {
  itemType: 'ACCOMMODATION';
  cmsItemId: string;
};
type Vote = 'up' | 'down' | 'doubleup' | 'doubledown';
const STORAGE_KEY = 'bw-jg-votes';
function useVote(t0) {
  const $ = _c(13);
  const {
    cmsItemId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [value, setValue] = useLocalStorage(STORAGE_KEY, t1 as Record<string, Vote>);
  const [mounted, setMounted] = useState(false);
  const action = api.cms.vote.useMutation();
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== action || $[4] !== cmsItemId || $[5] !== setValue || $[6] !== value) {
    t4 = vote => {
      action.mutate({
        itemId: cmsItemId,
        addVote: vote,
        oldVote: value?.[cmsItemId]
      }, {
        onSuccess: () => {
          setValue({
            ...value,
            [cmsItemId]: vote
          });
        }
      });
    };
    $[3] = action;
    $[4] = cmsItemId;
    $[5] = setValue;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const setVote = t4;
  const t5 = mounted ? value?.[cmsItemId] ?? null : null;
  let t6;
  if ($[8] !== action.error || $[9] !== action.isPending || $[10] !== setVote || $[11] !== t5) {
    t6 = {
      vote: t5,
      setVote,
      isLoading: action.isPending,
      error: action.error
    };
    $[8] = action.error;
    $[9] = action.isPending;
    $[10] = setVote;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export function ThumbsUpAndDownVote(t0) {
  const $ = _c(76);
  const {
    itemType,
    cmsItemId
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== itemType || $[1] !== t) {
    t1 = t("content.feedback.vote_prompt", {
      itemType: itemType.toLowerCase()
    });
    $[0] = itemType;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const label = t1;
  const buttonStyle = t2 => {
    const {
      checked
    } = t2;
    return clsx("flex border-2 rounded-full justify-center items-center basis-1/4 py-1 px-2 cursor-pointer focus:outline-none focus:ring-2 ring-primary-500 focus:border-none disabled:cursor-not-allowed disabled:opacity-50 ", checked ? "bg-black text-white border-black" : "bg-white text-black", isLoading && "pointer-events-none");
  };
  let t3;
  if ($[3] !== cmsItemId) {
    t3 = {
      cmsItemId
    };
    $[3] = cmsItemId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    vote,
    setVote,
    isLoading: t4,
    error
  } = useVote(t3);
  const isLoading = t4;
  const T0 = Stack;
  const t5 = 2;
  let t6;
  if ($[5] !== label) {
    t6 = <Text variant="emphasis-1">{label}</Text>;
    $[5] = label;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = "flex relative items-center w-full";
  const t8 = isLoading && <div className="flex absolute justify-center items-center w-full h-full"><SimpleSpinner title="loading" /></div>;
  const T1 = RadioGroup;
  const t9 = clsx("w-full", isLoading && "opacity-20");
  let t10;
  if ($[7] !== label) {
    t10 = <Label className="sr-only">{label}</Label>;
    $[7] = label;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== buttonStyle) {
    t11 = t12 => {
      const {
        checked: checked_0
      } = t12;
      return buttonStyle({
        checked: checked_0
      });
    };
    $[9] = buttonStyle;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t) {
    t12 = t("aria.vote_hate");
    $[11] = t;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ThumbsDown decorative={true} size="large" color="currentColor" />;
    t14 = <ThumbsDown decorative={true} size="large" color="currentColor" />;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] !== isLoading || $[16] !== t11 || $[17] !== t12) {
    t15 = <Radio value="doubledown" disabled={isLoading} className={t11} aria-label={t12}>{t13}{t14}</Radio>;
    $[15] = isLoading;
    $[16] = t11;
    $[17] = t12;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== buttonStyle) {
    t16 = t17 => {
      const {
        checked: checked_1
      } = t17;
      return buttonStyle({
        checked: checked_1
      });
    };
    $[19] = buttonStyle;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t) {
    t17 = t("aria.vote_dislike");
    $[21] = t;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ThumbsDown decorative={true} size="large" color="currentColor" />;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== isLoading || $[25] !== t16 || $[26] !== t17) {
    t19 = <Radio value="down" disabled={isLoading} className={t16} aria-label={t17}>{t18}</Radio>;
    $[24] = isLoading;
    $[25] = t16;
    $[26] = t17;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== buttonStyle) {
    t20 = t21 => {
      const {
        checked: checked_2
      } = t21;
      return buttonStyle({
        checked: checked_2
      });
    };
    $[28] = buttonStyle;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t) {
    t21 = t("aria.vote_like");
    $[30] = t;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ThumbsUp decorative={true} size="large" color="currentColor" />;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== isLoading || $[34] !== t20 || $[35] !== t21) {
    t23 = <Radio disabled={isLoading} value="up" className={t20} aria-label={t21}>{t22}</Radio>;
    $[33] = isLoading;
    $[34] = t20;
    $[35] = t21;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== buttonStyle) {
    t24 = t25 => {
      const {
        checked: checked_3
      } = t25;
      return buttonStyle({
        checked: checked_3
      });
    };
    $[37] = buttonStyle;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t) {
    t25 = t("aria.vote_love");
    $[39] = t;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  let t27;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <ThumbsUp decorative={true} size="large" color="currentColor" />;
    t27 = <ThumbsUp decorative={true} size="large" color="currentColor" />;
    $[41] = t26;
    $[42] = t27;
  } else {
    t26 = $[41];
    t27 = $[42];
  }
  let t28;
  if ($[43] !== isLoading || $[44] !== t24 || $[45] !== t25) {
    t28 = <Radio disabled={isLoading} value="doubleup" className={t24} aria-label={t25}>{t26}{t27}</Radio>;
    $[43] = isLoading;
    $[44] = t24;
    $[45] = t25;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t15 || $[48] !== t19 || $[49] !== t23 || $[50] !== t28) {
    t29 = <div className="flex gap-y-2 py-2 space-x-1 sm:py-1">{t15}{t19}{t23}{t28}</div>;
    $[47] = t15;
    $[48] = t19;
    $[49] = t23;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== T1 || $[53] !== isLoading || $[54] !== setVote || $[55] !== t10 || $[56] !== t29 || $[57] !== t9 || $[58] !== vote) {
    t30 = <T1 className={t9} disabled={isLoading} value={vote} onChange={setVote}>{t10}{t29}</T1>;
    $[52] = T1;
    $[53] = isLoading;
    $[54] = setVote;
    $[55] = t10;
    $[56] = t29;
    $[57] = t9;
    $[58] = vote;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t30 || $[61] !== t8) {
    t31 = <div className={t7}>{t8}{t30}</div>;
    $[60] = t30;
    $[61] = t8;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== error || $[64] !== t || $[65] !== vote) {
    t32 = vote && !error && <Text variant="body-1">{t("content.feedback.vote_success")}</Text>;
    $[63] = error;
    $[64] = t;
    $[65] = vote;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== error || $[68] !== t) {
    t33 = error && <Text variant="body-1">{t("content.feedback.vote_error")}</Text>;
    $[67] = error;
    $[68] = t;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== T0 || $[71] !== t31 || $[72] !== t32 || $[73] !== t33 || $[74] !== t6) {
    t34 = <T0 spacing={t5}>{t6}{t31}{t32}{t33}</T0>;
    $[70] = T0;
    $[71] = t31;
    $[72] = t32;
    $[73] = t33;
    $[74] = t6;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  return t34;
}